/**
 * Ponto de entrada da aplicação MEDICARE
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { ColorModeScript } from '@chakra-ui/react';
import App from './App';
import { theme } from './theme';
import reportWebVitals from './reportWebVitals';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elemento root não encontrado');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <App />
  </React.StrictMode>
);

// Medição de performance (opcional)
reportWebVitals();